import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionRoomKeyVisual } from "./key-visual";
import { QuestionCatchCopy } from "./main-target";
import { QuestionRoomName } from "./name";

import type { StandardRoomCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	hotelID: string;
	roomID: string;

	base: StandardRoomCategoriesAndManagerStore["base"];
};

export const QuestionRoomBase = ({ hotelID, roomID, base }: Props) => {
	const ownerID = hotelID;
	const resourceID = roomID;

	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={base}>
			<QuestionRoomName />
			<QuestionCatchCopy />
			<QuestionRoomKeyVisual ownerID={ownerID} resourceID={resourceID} />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionRoomBase.displayName = "QuestionRoomBase";
